"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabsGroupColors = exports.TabsGroupVariants = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    button: {
      color: theme.palette.grey[800],
      fontSize: theme.typography.body1.fontSize,
      height: theme.spacing(6),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      transition: theme.transitions.create(["background-color", "color"], {
        duration: theme.transitions.duration.standard
      }),
      "&:not(:last-child)": {
        borderColor: "transparent",
        marginRight: 1
      }
    },
    white: {
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.grey[200]
      }
    },
    grey: {
      backgroundColor: theme.palette.grey[200],
      "&:hover": {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.grey[300]
      }
    },
    primary: {
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      }
    },
    secondary: {
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main
      }
    },
    selected: {
      color: theme.palette.common.white,
      pointerEvents: "none"
    }
  };
});
/**
 * ** Tabs organise content across different screens, data sets, and other interactions. **
 *
 * Tabs keeps related content in a single container that is shown and hidden through navigation. Content is separated into different panes, and each pane is viewable one at a time.
 *
 * The lighter grey and red tabs are active.
 *
 * When it is used with other types of tabs, it is always displayed at the lower level.
 */

var TabsGroup = function TabsGroup(_ref) {
  var tabs = _ref.tabs,
      action = _ref.action,
      variant = _ref.variant,
      color = _ref.color,
      selected = _ref.selected;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.ButtonGroup, {
    variant: "contained",
    "aria-label": "contained primary button group"
  }, tabs.map(function (tab, index) {
    var _classNames;

    return /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.button, true), _defineProperty(_classNames, styles.selected, selected === index), _defineProperty(_classNames, styles[color], true), _defineProperty(_classNames, styles[variant], selected === index), _classNames)),
      onClick: function onClick() {
        return action && action(index);
      }
    }, tab);
  }));
};

TabsGroup.propTypes = {
  /** Array of values to be represented as tabs  */
  tabs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /** The index of the tab that will have the selected state   */
  selected: _propTypes.default.number,

  /** The color variation of the TabsGroup  */
  color: _propTypes.default.oneOf(["white", "grey"]),

  /** The selected state variation of the TabsGroup  */
  variant: _propTypes.default.oneOf(["primary", "secondary"]),

  /** Callback fired when the value changes. function(value: any) => void  */
  action: _propTypes.default.func.isRequired
};
TabsGroup.defaultProps = {
  selected: 0,
  color: "white",
  variant: "primary"
};
var TabsGroupVariants = ["primary", "secondary"];
exports.TabsGroupVariants = TabsGroupVariants;
var TabsGroupColors = ["white", "grey"];
exports.TabsGroupColors = TabsGroupColors;
var _default = TabsGroup;
exports.default = _default;